import {GET_ROBOTS_AND_VEHICLES_ERROR} from "../../../reducers/robotsAndVehiclesReducer";


export const getRobotsError = (error) =>{
    return {
        type: GET_ROBOTS_AND_VEHICLES_ERROR,
        payload: {error}
    }
}